import {axiosInstance} from "../../../config/axiosInstance";
import {CONSTANTS} from "../../../constants/constants";

const API_VERSION_V1 = CONSTANTS.API.API_VERSION.V1;

export const PAYMENT_API = {
  getStatus: async () => (
    await axiosInstance.get(`${API_VERSION_V1}/payment/status`)
  ),
  getCurrencies: async () => (
    await axiosInstance.get(`${API_VERSION_V1}/payment/currencies`)
  ),
};